<template>
  <div class="shard-detail-view lfs-box-shadow v_sub_bg"
       id="shard-detail-view">
    <div class="shard-detail-view__close v_text_default--text">
      <div @click="closeSelectedShard">
        <span class="v_text_default--text">{{ $t('shardList.detail.close') }}</span>

        <x-icon size="20"/>
      </div>
    </div>

    <div class="shard-detail-view__options"
         :style="
           (selectedShard.surveyData.answers.length ||
             selectedShard.media.filter((item) => item.type === 'note').length) &&
           !(
             selectedShard.surveyData.answers.length &&
             selectedShard.media.filter((item) => item.type === 'note').length
           )
             ? 'justify-content: left;'
             : ''
         ">
      <div class="shard-detail-view__options-item "
           :class="{
             'shard-detail-view__options-item_active  v_pl': detailViewState === 'info'
           }"
           :id="detailViewState == 'info' ? 'selected-detail-view-option' : ''"
           @click="detailViewState = 'info'">
        <v-icon :class="
            detailViewState === 'info' ? 'shard-detail-view__options-item_active  v_pl': 'v_text_default--text'
           " :size="18">
          mdi-information
        </v-icon>

        <p :class="
            detailViewState === 'info' ? 'shard-detail-view__options-item_active  v_pl': 'v_text_default--text'
           ">
          {{ $t('shardList.detail.information') }}
        </p>
      </div>

      <div class="shard-detail-view__options-item  "
           :class="{
             'shard-detail-view__options-item_active v_pl  ': detailViewState === 'survey'
           }"
           :id="detailViewState == 'survey' ? 'selected-detail-view-option' : ''"
           @click="detailViewState = 'survey'">
        <v-icon :size="18" :class="
            detailViewState === 'survey' ? 'shard-detail-view__options-item_active  v_pl': 'v_text_default--text'
           ">
          mdi-clipboard-text
        </v-icon>

        <p :class="
            detailViewState === 'survey' ? 'shard-detail-view__options-item_active  v_pl': 'v_text_default--text'
           ">
          {{ $t('shardList.detail.survey') }}
        </p>
      </div>

      <div class="shard-detail-view__options-item"
           :class="{
             'shard-detail-view__options-item_active  v_pl': detailViewState === 'notes'
           }"
           :id="detailViewState == 'notes' ? 'selected-detail-view-option' : ''"
           @click="detailViewState = 'notes'">
        <v-icon :size="18" :class="
            detailViewState === 'notes' ? 'shard-detail-view__options-item_active  v_pl': 'v_text_default--text'
           ">
          mdi-square-edit-outline
        </v-icon>

        <p :class="
            detailViewState === 'notes' ? 'shard-detail-view__options-item_active  v_pl': 'v_text_default--text'
           ">
          {{ $t('shardList.detail.notes') }}
        </p>
      </div>
    </div>

    <div v-if="detailViewState === 'info'">
      <div v-if="selectedShard.target_type === 'product'">
        <div class="box image v_sub_bg">
          <div class="img"
               v-if="selectedShard.target && selectedShard.target.photo && selectedShard.target.photo.length">
            <img :src="imageById(selectedShard._id)"
                 alt="">

            <div class="stand-title v_text_default--text">
              {{ selectedShard.standTitle }}
            </div>
          </div>

          <div v-if="selectedShard.target || selectedShard.subtitle"
               class="box-item v_text_subtitle--text">
            <div v-if="selectedShard.target">
              <b>
                <span class="v_text_default--text">{{ selectedShard.target.title }}</span>
              </b>
            </div>

            <div class="v_text_subtitle--text">
              {{ selectedShard.subtitle }}
            </div>
          </div>
          <div class="box-item v_text_subtitle--text">
            <p>
              {{ $t('shardList.detail.company') }}
            </p>

            <b>
              <span class="v_text_default--text">{{ companyName() }}</span>
            </b>
          </div>
        </div>

        <div class='box characters v_sub_bg'>

          <div class='box-title '>
            <img class='lfs-pd-icon' style="color: blue" src='/product-icon-menu-active.svg'>
            <span style='position: relative; top: 1px' class="v_btn_default--text">
              {{ $t('shardList.detail_shard.description') }}
            </span>
          </div>

          <div class="box-item ">
            <div></div>
            <div class="v_text_subtitle--text"> {{ description }}</div>

          </div>

        </div>

        <div v-if="characters && characters.length"
             class="box characters v_sub_bg">
          <div class="box-title v_btn_default--text">
            <maximize-2-icon size="20"
                             class="icon"/>

            {{ $t('shardList.detail.properties') }}
          </div>
          <div v-for="(c, index) in characters"
               :key="index"
               class="box-item v_sub_bg">
            <div class="v_text_default--text">
              {{ c.title }}
            </div>

            <div class="v_text_subtitle--text">
              {{ c.value }}
            </div>
          </div>
        </div>


        <div v-if="selectedShard.target && selectedShard.target.promo.length"
             class="box v_sub_bg">
          <div class="box-title v_btn_default--text">
            <link-2-icon size="20"
                         class="icon v_btn_default--text"/>

            {{ $t('shardList.detail.links') }}
          </div>

          <div v-for="(link, index) in selectedShard.target.promo"
               :key="index"
               class="box-item v_btn_default--text">
            <div class="v_text_default--text">
              {{ link.title }}
            </div>

            <div class="link ">
              <a :href="link.value.substring(0,4).indexOf('http') === -1 ? 'https://'+ link.value : link.value"
                 target="_blank" class="v_btn_default--text">
                {{ link.value.substring(0, 4).indexOf('http') === -1 ? 'https://' + link.value : link.value }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="selectedShard.target_type === 'company'"
             class="box image v_sub_bg">
          <div v-if="selectedShard.target.photo" class="img">
            <img :src="imageById(selectedShard._id)" alt="">
          </div>

          <div class="box-item v_text_default--text">
            <div>
              {{ $t('shardList.detail.company').toLowerCase() }}
            </div>
            <div class="company-title v_text_subtitle--text">
              {{ selectedShard.title }}
            </div>
          </div>
        </div>
        <div v-else-if="selectedShard.target_type === 'badge' || selectedShard.target_type === 'custom_contact'"
             class="box image v_sub_bg ">
          <div v-if="selectedShard.target.photo"
               class="img">
            <img :src="imageById(selectedShard._id)"
                 alt="">
          </div>
          <div class="box-item v_text_subtitle--text">
            <div>
              {{
                selectedShard.target.role === 'standman'
                  ? $t('shardList.detail.member')
                  : $t('shardList.detail.visitor')
              }}
            </div>

            <div class="member v_text_default--text">
              {{ selectedShard.title }}
            </div>
          </div>
          <div class="box-item">
            <div class="company-title v_text_subtitle--text">
              {{ selectedShard.target.companyTitle }}
            </div>

            <div class="v_text_default--text">
              {{ selectedShard.target.position }}
            </div>
          </div>
        </div>
        <div v-if="selectedShard.target"
             class="box contacts v_sub_bg">
          <div class="box-title" v-if="selectedShard.target && selectedShard.target.contacts.length">
            <p class="v_btn_default--text">
              <book-icon size="18.33"
                         class="icon v_btn_default--text"/>

              {{ $t('shardList.detail.contacts') }}
            </p>
          </div>

          <div v-if="selectedShard.target && selectedShard.target.contacts.length">
            <div v-for="(contact, index) in contacts"
                 :key="index"
                 class="box-item">

              <p v-if="contact.title"
                 class="box-item-title v_text_subtitle--text">
                {{ contact.title }}
              </p>

              <div class="v_text_default--text">
                {{ contact.value }}
              </div>

            </div>
            <div  class="box-item"
                  v-if="selectedShard.target.locations && selectedShard.target.locations.length>0">

              <p   class="box-item-title v_text_subtitle--text">
                {{ $t('profile.address.address') }}
              </p>
              <div class="v_text_default--text"
                   v-for="(location,ind) in selectedShard.target.locations " :key="ind">
                {{ location.postcode }}
                {{ location.region }}
                {{ location.city }}
                {{ location.address }}
              </div>
            </div>
          </div>

        </div>

        <div class="box about v_sub_bg"
             v-if="selectedShard.target && selectedShard.target.about ">
          <div class="box-title v_sub_bg">
            <align-left-icon size="20" class="icon"/>
            {{ $t('profile.title_about') }}
          </div>
          <div class="box-item v_text_subtitle--text">
            {{ selectedShard.target.about }}
          </div>
        </div>

        <div class="box about v_sub_bg" v-if="description">
          <div class="box-title v_sub_bg">
            <align-left-icon size="20" class="icon"/>
            {{ $t('shardList.detail.about') }}
          </div>
          <div class="box-item v_text_subtitle--text">
            {{ description }}
          </div>
        </div>
        <div v-if="selectedShard.target && selectedShard.target.promo.length"
             class="box links v_sub_bg">
          <div class="box-title v_btn_default--text">
            <link-2-icon size="20"
                         class="icon"/>

            {{ $t('shardList.detail.links') }}
          </div>

          <div v-for="(link, index) in selectedShard.target.promo"
               :key="index"
               class="box-item v_text_subtitle--text">
            <div>
              {{ link.title }}
            </div>

            <div class="link">
              <a :href="link.value.substring(0,4).indexOf('http') === -1 ? 'https://'+ link.value : link.value"
                 target="_blank" class="v_btn_default--text">
                {{ link.value.substring(0, 4).indexOf('http') === -1 ? 'https://' + link.value : link.value }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="pendingType"
           class="shard-detail-view__pending ">
        <div class="shard-detail-view__pending-attr v_sub_bg">
          <p class="v_text_subtitle--text">
            {{ pendingTitle }}
          </p>

          <span class="v_text_default--text">
            {{ selectedShard._target }}
          </span>
        </div>

        <div class="shard-detail-view__pending-attr v_sub_bg">
          <p class="v_text_subtitle--text ">
            {{ $t('shardList.detail_shard.wait_data') }}
          </p>

          <span class="v_text_default--text">
             {{ $t('shardList.detail_shard.server_load') }}
          </span>
        </div>
      </div>
    </div>


    <div v-if="detailViewState === 'survey'">
      <template v-if="survey">
        <div v-for="question in sortedSurvey"
             :key="question.id"
             class="shard-detail-view__survey v_sub_bg">
          <div class="shard-detail-view__survey-title">
            <p class="v_text_default--text">
              {{ question.text }}
            </p>
          </div>

          <div v-for="answer in question.answers"
               :key="answer.id"
               class="shard-detail-view__survey-answer v_text_subtitle--text">
            {{ answer.value }}
          </div>
        </div>
      </template>
    </div>

    <div v-if="detailViewState === 'notes'">
      <div v-for="(note, index) in selectedShard.media"
           :key="index"
           class="box note v_sub_bg">
        <div class="box-item v_text_default--text">
          {{ note.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'

import {
  Maximize2Icon,
  AlignLeftIcon,
  FileTextIcon,
  Link2Icon,
  InfoIcon,
  EditIcon,
  BookIcon,
  XIcon,
} from 'vue-feather-icons'

export default {
  name: "ShardDetailView",
  props: {
    selectedShard: Object,
    companies: Array,
  },
  components: {
    Maximize2Icon,
    AlignLeftIcon,
    FileTextIcon,
    Link2Icon,
    InfoIcon,
    EditIcon,
    BookIcon,
    XIcon,
  },
  data() {
    return {
      detailViewState: 'info',
      survey: null,
    };
  },
  computed: {
    ...mapGetters('resources', ['imageById']),
    ...mapGetters('survey', ['surveyById']),
    ...mapState('auth', ['exhibitorId']),

    contacts: function () {
      return this.selectedShard.target.contacts.sort((a, b) => {
        return a.order > b.order ? 1 : -1;
      });
    },

    pendingType() {
      const regexp = /pending_/
      const type = this.selectedShard.target_type

      if (regexp.test(type)) {
        return type.substring(8, type.length)
      }

      return ''
    },

    pendingTitle() {
      switch (this.pendingType) {
        case 'badge':
          return 'Бейдж'

        case 'stand':
          return 'Стенд'

        case 'product':
          return 'Продукт'

        default:
          return ''
      }
    },

    sortedSurvey() {

      const questions = this.surveyById(this.selectedShard.surveyData._survey).questions;
      const answers = this.selectedShard.surveyData.answers;

      let questionsWithAnswers = Object.entries(answers.reduce(function (result, sd_answer) {

        const question = questions.find((question) =>
          question.answers.some((answer) => sd_answer.id == answer.id)
        );

        if (question) {
          if (result[question.id])
            result[question.id].answers.push(sd_answer);
          else
            result[question.id] = {text: question.text, id: question.id, order: question.order, answers: [sd_answer]};
        }

        return result;

      }, {}));

      return questionsWithAnswers
        // Убираем лишние id-шники
        .map(
          question => question[1]
        )
        // Сортировка ответов в вопросах
        .map(
          question => {
            question.answers.sort(
              (a, b) => a.order < b.order
                ? -1
                : a.order > b.order
                  ? 1
                  : 0
            );
            return question;
          }
        )
        // Сортировка вопросов
        .sort(
          (a, b) => a.order < b.order
            ? -1
            : a.order > b.order
              ? 1
              : 0
        );

    },

    characters() {
      return this.selectedShard.target ? this.selectedShard.target.characters : []
    },

    description() {
      return this.selectedShard.target && this.selectedShard.target.description
        ? this.selectedShard.target.description
        : false
    }
  },
  methods: {
    ...mapActions('resources', ['addImage']),
    ...mapActions('survey', ['load']),

    companyName() {
      const comName = this.companies.find((company) => company.id === this.selectedShard._company)

      return comName ? comName.name : ''
    },

    async getSurvey() {
      this.survey = this.surveyById(this.selectedShard.surveyData._survey)
    },

    closeSelectedShard() {
      this.$emit('closeSelectedShard')
    }
  },

  watch: {
    selectedShard(newVal) {
      let notes = newVal.media.filter((item) => {
        return item.type === 'note'
      }).length === 0
      let answers = newVal.surveyData.answers.length === 0

      if (notes && this.detailViewState === 'notes') {
        this.detailViewState = 'info'
      }
      if (this.detailViewState === 'survey' && answers) {
        this.detailViewState = 'info'
      }
      if (
        this.selectedShard.target &&
        this.selectedShard.target.photo &&
        !this.imageById(this.selectedShard._id)
      ) {
        this.addImage({
          photoKey: this.selectedShard.target.photo,
          shardId: this.selectedShard._id
        })
      }

      if (this.selectedShard.surveyData.answers.length) {
        this.getSurvey()
      }
    }
  },

  mounted: function () {
    if (this.selectedShard.surveyData.answers.length) {
      this.getSurvey()
    }

    if (this.selectedShard.target && this.selectedShard.target.photo) {
      this.addImage({
        photoKey: this.selectedShard.target.photo,
        shardId: this.selectedShard._id
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.shard-detail-view {
  min-width: 376px;
  max-width: 336px;
  height: 100vh;

  background: white;

  padding-left: 20px;
  padding-right: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);

  position: fixed;
  right: 0;
  top: 0;

  overflow-y: scroll;

  z-index: 2;

  &__close {
    width: 100%;

    margin-top: 20px;
    margin-bottom: 24px;

    font-size: 16px;
    font-weight: bold;
    line-height: 12px;
    letter-spacing: -0.24px;
    color: #363636 !important;
    text-align: right;

    right: 0px;

    cursor: pointer;
  }

  &__options {
    width: 100%;

    display: flex;
    justify-content: space-around;

    font-weight: bold;
    font-size: 12px;
    line-height: 12px;
    color: #828282;
    letter-spacing: -0.24px;

    margin-bottom: 22px;

    top: 0;

    img {
      color: #828282;
    }

    &-item {
      display: flex;
      align-items: center;

      background-color: transparent;

      padding: 12px;
      border-radius: 8px;

      color: #C4C4C4;

      cursor: pointer;

      .v-icon {
        margin-right: 7px;

        color: #C4C4C4;
      }

      &:not(:last-child) {
        margin-right: 10px;
      }

      &_active {
        background-color: #E3F5FF;

        color: #2D9CDB;

        .v-icon {
          color: #2D9CDB;
        }
      }

      & > p {
        font-size: 12px;
        font-weight: normal;
        line-height: 12px;
        color: inherit;

        margin-bottom: 0 !important;
      }
    }
  }

  &__pending {
    display: flex;
    flex-direction: column;

    &-attr {
      background-color: #F3F2F7;

      font-size: 14px;

      padding: 13px 20px;
      border-radius: 8px;

      p {
        font-weight: 700;
        color: #363636;

        padding-bottom: 11px;
        margin-bottom: 0 !important;
      }

      span {
        color: #828282;
      }

      &:not(:last-child) {
        margin-bottom: 20px;
      }
    }
  }

  &__custom {
    &-head {
      background-color: #F3F2F7;

      font-size: 14px;
      color: #363636;

      padding: 13px 20px;
      border-radius: 8px;

      small {
        font-size: 14px;

        padding-bottom: 9px;
      }

      strong {
        font-size: 16px;
        font-weight: 700;

        padding-bottom: 10px;
      }

      p {
        font-size: 16px;

        padding-bottom: 6px;
      }

      span {
        font-size: 14px;
      }
    }
  }

  &__box {
    background-color: #f3f2f7;

    margin-bottom: 46px;
    border-radius: 8px;

    position: relative;

    overflow: visible;

    &-title {
      display: flex;
      align-items: center;

      font-weight: bold;
      font-size: 12px;
      line-height: 20px;
      color: #2d9cdb;
      letter-spacing: -0.24px;
      text-transform: uppercase;
      font-feature-settings: "tnum" on, "lnum" on;

      margin-bottom: 9px;

      svg {
        margin-right: 8px;
      }
    }

    &-item {
      padding: 13px 0;
      margin: 0 20px !important;
    }

    &-img {
      position: relative;

      overflow: hidden;

      &-title {
        background-color: #f3f2f7;

        font-weight: bold;
        color: #363636;

        padding: 10px;
        border-bottom-left-radius: 8px;

        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }

  &__survey {
    width: 100%;

    background-color: #F3F2F7;

    padding: 0 20px;
    border-radius: 8px;
    margin-bottom: 15px;

    &-title {
      min-height: 50px;

      padding: 15px 0;

      p {
        margin-bottom: 0 !important;

        font-size: 16px;
        font-weight: 700;
        color: #363636;
        line-height: 22px;
      }

      &:not(:last-child) {
        border-bottom: 1px solid #D9D9D9A3;
      }
    }

    &-answer {
      min-height: 50px;

      padding: 17px 0;

      font-size: 14px;
      font-weight: normal;
      color: #828282;
      line-height: 17px;

      &:not(:last-child) {
        border-bottom: 1px solid #D9D9D9A3;
      }
    }
  }
}

.box {
  border-radius: 8px;
  background: #f3f2f7;
  position: relative;
  margin-bottom: 46px;
  overflow: visible;

  .box-item {
    margin: 0 20px !important;
    padding: 13px 0;
  }

  .box-title {
    font-weight: bold;
    font-size: 12px;
    line-height: 20px;
    color: #2d9cdb;
    letter-spacing: -0.24px;
    text-transform: uppercase;
    font-feature-settings: "tnum" on, "lnum" on;

    position: absolute;
    top: -29px;

    p {
      display: flex;
      align-items: center;
    }

    svg {
      margin-left: 0 !important;

      transform: translateY(-1px);
    }
  }
}

.box-title {
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

#selected-detail-view-option {
  color: var(--v-v_btn_default-base) !important;

  img {
    color: #2d9cdb;
  }
}


.icon {
  margin-right: 8px !important;
}

.contacts {
  box-item:not(:last-child) {
    border-bottom: 1px solid rgba(217, 217, 217, 0.64);
  }
}

.contacts {
  .box-item {
    &-title {
      font-weight: bold;
      font-size: 14px;
      line-height: 20px;
      font-feature-settings: "tnum" on, "lnum" on;
      color: #363636;
    }
  }
}

.notes {
  .title {
    font-size: 14px;
    line-height: 20px;
    font-feature-settings: "tnum" on, "lnum" on;
    color: #363636;
  }
}

.company-title {
  font-weight: bold;
  font-size: 16px;
  line-height: 30px;
  color: #363636;
}

.box.badge-info-box {
  padding-top: 0;
}

.member {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 30px;
  color: #363636;
}

.box-item:not(:last-child) {
  border-bottom: 1px solid rgba(217, 217, 217, 0.64);
}

.characters {
  .box-item {
    *:last-child {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 17px;
      color: #828282;
    }
  }
}

.note.box {
  padding: 0px;
}

.box.main.product {
  padding-top: 0;
}

.image {
  position: relative;
  overflow: hidden;

  .stand-title {
    position: absolute;
    top: 0;
    right: 0;
    background: #f3f2f7;
    border-bottom-left-radius: 8px;
    padding: 10px;
    font-weight: bold;
    color: #363636;
  }
}

img {
  width: 100%;
}

.question-title {
  font-weight: bold;
  font-size: 16px;
  line-height: 30px;
  color: #363636;
  margin: 0;
}

.shard-answer {
  font-size: 14px;
  line-height: 30px;
  color: #828282;
}

.box-item div {
  word-break: break-word;
}


</style>
